/**
 * 首次进入应用时的链接解析, 并做对应的信息设置和存储
 */

import { parseUrl, isBrowser } from '@mc/base';
import { a8Integration, impactIntegration } from '@/utils';

if (isBrowser()) {
  /** 解析路径上的参数 */
  const { a8, irclickid } = parseUrl(window.location.href).query;

  a8Integration(a8 as string);

  impactIntegration(irclickid as string);

  /** 移除路由参数 不触发页面刷新 */
  // window.history.replaceState({}, document.title, window.location.pathname);
}
